module.exports = __webpack_public_path__ + "static/img/16.3d4ee858.gif";